import React, { useState } from 'react'

// Deps
import { connect } from 'react-redux';

// Functions

// Partials
import Btn from 'views/shared/partials/btn'
import { InputForm, FormInput } from 'views/shared/partials/forms'

// Services
import orderServices from 'services/order'

// Assets

// Data
const languageOptions = [
	{ value: 'tr', label: 'TR' },
	{ value: 'en', label: 'EN' },
]

const mapStateToProps = (state, ownProps) => {
	return {
		mobileState: state.site.mobile,
	};
};

const OrderPaymentLinkModal = ({mode, order, close, closeBtn, onSuccess, mobileState, ...props}) => {
	const [submitting, setSubmitting] = useState(false);

	const sendLink = (formData) => {
		setSubmitting(true);

		let submitData = {
			order_business_code: order.business_order_code,
			language: formData.language,
		}

		if(mode === 'email') {
			submitData.email = formData.input;
		}
		else {
			submitData.phone_number = formData.input.replace(/\+9/, '').replace(/ /g,'');
		}

		orderServices.sendNotification(submitData).then(() => {
			if(onSuccess) {
				onSuccess();
			}

			setTimeout(() => {
				close();
			}, 50)
		}).catch(() => {
		}).finally(() => {
			setSubmitting(false);
		})
	}

	return (
		<div className={props.className}>
			{/*closeBtn*/}
			<div className="modal-content">
				{!mobileState ? closeBtn : false}
				<InputForm className="link-form" onSubmit={sendLink}>
					{mode === 'email' ?
						<React.Fragment>
							<FormInput
								key="input_email"
								name="input"
								disabled={submitting}
								validation={{
									required: 'E-posta adresi girmelisiniz.',
									email: 'Geçerli bir e-posta girmelisiniz.'
								}}
								value={(order.client && order.client.client_code !== 'anonim') ? order.client.email : undefined}
								className="form-input low target"
								placeholder="E-Posta adresi giriniz"
								type="text" />
						</React.Fragment>
						:
						<React.Fragment>
							<FormInput
								key="input_phone"
								name="input"
								disabled={submitting}
								validation={{
									required: 'Telefon numarası girmelisiniz.'
								}}
								value={(order.client && order.client.client_code !== 'anonim') ? order.client.phone_number : undefined}
								className="form-input low target"
								placeholder="Cep telefonu giriniz"
								type="text" />
						</React.Fragment>
					}
					<FormInput
						name="language"
						disabled={submitting}
						validation={{
							required: 'Bir gönderim dili seçmelisiniz.',
						}}
						className="form-input low language"
						defaultValue={languageOptions[0]}
						options={languageOptions}
						type="select" />
					<Btn
						disabled={submitting}
						loading={submitting}
						type="submit">
						Gönder
					</Btn>
				</InputForm>

				{mobileState &&
					<button
						className="link-closebtn"
						onClick={close}
						type="button">
						<i className="icon-angle-down-thin"></i> Vazgeç
					</button>
				}
			</div>
		</div>
	)
}

const ConnectedModal = connect(mapStateToProps)(OrderPaymentLinkModal);

ConnectedModal.defaultProps = {
	className: '',
	containerClass: 'modal-order-payment-link modal-from-bottom',
	name: 'order-payment-link',
	mode: 'email',
	link: '',
}

export default ConnectedModal
